// extracted by mini-css-extract-plugin
export default {"wrapper":"Eba-z","boldPrefix":"Fba-z","link":"Gba-z","message":"Hba-z","image":"Iba-z"};